import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Loader from 'src/components/loader/loader';
import Label from 'src/components/label/Label';
import ConfirmMessages from 'src/components/modal/ConfirmMessages';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const UpdateDeviceLocationExcelModal = ({
    setDataExcel,
    visible = false,
    dataExcel,
    setVisible,
    fuctGet,
    isEdit,
    property,
}) => {
    const { t } = useTranslation();
    const [flagAddStat, setFlagAddStat] = useState(false);
    const [dataRender, setDataRender] = useState([]);
    const addFlag = useRef(false);
    const [visibleConfirm, setVisibleConfirm] = useState(false);
    useEffect(() => {
        setDataRender(dataExcel);
    }, [dataExcel]);

    let errorCount = 0;
    dataExcel.forEach((item) => {
        if (item[7] === 'ERR' || item[7] === 'WRN') {
            errorCount++;
        }
    });

    const handleEdit = () => {
        if (addFlag.current === true) return;
        addFlag.current = true;
        setFlagAddStat(true);

        const InVal = [];
        sendRequest(serviceList.submitTempDeviceLocation, InVal, actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();
            setDataExcel([]);
            deleteTableExcel();
            setVisible(!visible);
            setVisibleConfirm(false);
        }
    };
    const timeOutFunct = (reqInfo) => {
        addFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out') + 2);
    };

    const deleteTableExcel = () => {
        const InVal = [];
        sendRequest(serviceList.delExcelDevice, InVal, deleteExcelResult, true, timeOutDeleteTabbelExcel, 40000);
    };

    const deleteExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            setDataExcel([]);
        }
    };
    const timeOutDeleteTabbelExcel = (reqInfo) => {};

    const renderErr = (arrErr = []) => {
        let textErr = '';
        arrErr.map((err) => {
            textErr += ' ' + err;
        });
        return textErr;
    };

    const handleOnClick = () => {
        if (errorCount > 0) {
            setVisibleConfirm(true);
        } else {
            handleEdit();
        }
    };

    return (
        <BootstrapDialog
            fullScreen
            open={visible}
            onClose={() => {
                deleteTableExcel();
                setDataExcel([]);
                setVisible(!visible);
            }}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle
                id="customized-dialog-title"
                onClose={() => {
                    deleteTableExcel();
                    setDataExcel([]);
                    setVisible(!visible);
                }}
            >
                {t('confirm_info')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <ConfirmMessages
                visible={visibleConfirm}
                setVisible={setVisibleConfirm}
                handleSave={handleEdit}
                title={t('warning')}
                mesages={t('message_confirm_import_excel')}
            />
            <DialogContent dividers>
                <Alert
                    sx={{ alignItems: 'flex-start', marginBottom: '20px', width: { md: '50%', sm: '100%' } }}
                    severity="warning"
                >
                    <div>
                        <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                            {t('note')}
                        </Typography>
                        <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                            {t('err_excel')}
                        </Typography>
                    </div>
                </Alert>
                <TableContainer>
                    <Table sx={{ paddingLeft: 2 }}>
                        {/* <UserListHead headLabel={TABLE_HEAD} /> */}
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('device_cd_old')}</TableCell>
                                <TableCell>{t('device_cd_new')}</TableCell>
                                <TableCell>{t('name_device')}</TableCell>
                                <TableCell>{t('code_supplier')}</TableCell>
                                <TableCell>{t('producer')}</TableCell>
                                <TableCell>{t('quan_ly_bo_phan')}</TableCell>
                                <TableCell>{t('price')}</TableCell>
                                <TableCell>{t('status_device')}</TableCell>
                                <TableCell>{t('checking_after')}</TableCell>
                                <TableCell>{t('can_grinding')}</TableCell>
                                <TableCell>{t('cabinet_code_old')}</TableCell>
                                <TableCell>{t('id_drawer_old')}</TableCell>
                                <TableCell>{t('cell_old')}</TableCell>
                                <TableCell>{t('cabinet_code_new')}</TableCell>
                                <TableCell>{t('id_drawer_new')}</TableCell>
                                <TableCell>{t('cell_new')}</TableCell>
                                <TableCell>{t('note_')}</TableCell>
                                {property?.length > 0 &&
                                    property.map((item, index) => (
                                        <TableCell key={index} align="right">
                                            {item?.label}
                                        </TableCell>
                                    ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataRender.length > 0 &&
                                dataRender.map((item, index) => {
                                    {
                                        /* console.log(2121, item); */
                                    }
                                    return (
                                        <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                            <TableCell>{item.device_cd_old ? item.device_cd_old : ''}</TableCell>
                                            <TableCell>{item.device_cd_new ? item.device_cd_new : ''}</TableCell>
                                            <TableCell>{item.device_nm ? item.device_nm : ''}</TableCell>
                                            <TableCell>{item.supplier_cd ? item.supplier_cd : ''}</TableCell>
                                            <TableCell>{item.producer ? item.producer?.label : ''}</TableCell>
                                            <TableCell>
                                                {item.depart_id?.length > 0 &&
                                                    item.depart_id.map((value) => {
                                                        let str = '';
                                                        str += value.label + ':  ' + value.value + ', ';
                                                        return str;
                                                    })}
                                            </TableCell>
                                            <TableCell>{item.price ? item.price : ''}</TableCell>
                                            <TableCell>{item.status_action ? item.status_action : ''}</TableCell>
                                            <TableCell>{item.expiry_date ? item.expiry_date : ''}</TableCell>
                                            <TableCell>{item.can_grinding ? item.can_grinding : ''}</TableCell>
                                            <TableCell>{item.cabinet_cd_old ? item.cabinet_cd_old : ''}</TableCell>
                                            <TableCell>{item.drawer_lc_old ? item.drawer_lc_old : ''}</TableCell>
                                            {item.cabinet_type_old ? (
                                                item.cabinet_type_old === 'square' ? (
                                                    <TableCell>
                                                        [ {item.cell_lc_old?.row} : {item.cell_lc_old?.column} ]
                                                    </TableCell>
                                                ) : (
                                                    <TableCell>{item.cell_lc_old?.column}</TableCell>
                                                )
                                            ) : (
                                                <TableCell>{''}</TableCell>
                                            )}
                                            <TableCell>{item.cabinet_cd_new ? item.cabinet_cd_new : ((item?.drawer_lc_new || item?.cell_lc_new) ? item.cabinet_cd_old : "")}</TableCell>
                                            <TableCell>{item.drawer_lc_new ? item.drawer_lc_new : ((item?.cabinet_cd_new || item?.cell_lc_new) ? item.drawer_lc_old : "")}</TableCell>
                                            {item.cabinet_type_new || item.cabinet_type_old ? (
                                                item.cabinet_type_new === 'square' ||
                                                item.cabinet_type_old === 'square' ? (
                                                    <TableCell>
                                                        [ {((item?.drawer_lc_new || item?.cell_lc_new) && !item.cell_lc_new) ?item.cell_lc_old.row : item.cell_lc_new?.row} : {((item?.drawer_lc_new || item?.cell_lc_new) && !item.cell_lc_new) ?item.cell_lc_old.column : item.cell_lc_new?.column} ]
                                                    </TableCell>
                                                ) : (
                                                    <TableCell>{((item?.drawer_lc_new || item?.cell_lc_new) && !item.cell_lc_new) ?item.cell_lc_old.column : item.cell_lc_new?.column}</TableCell>
                                                )
                                            ) : (
                                                <TableCell>{''}</TableCell>
                                            )}

                                            <TableCell align="left">
                                                <Typography
                                                    color={item.status_row !== 'ERR' ? 'text.success' : 'text.error'}
                                                >
                                                    {item.status_row !== 'ERR' && item.status_row !== 'WRN' && (
                                                        <Label color={'primary'}>{t('OK')}</Label>
                                                    )}
                                                    {item.status_row === 'WRN' && (
                                                        <Label color={'warning'}>{renderErr(item.note)}</Label>
                                                    )}
                                                    {item.status_row === 'ERR' && renderErr(item.note)}
                                                    {/* {item[7] !== 'ERR' ? (
                                                        <Label color={'primary'}>{t('OK')}</Label>
                                                    ) : (
                                                        renderErr(item[8])
                                                    )} */}
                                                </Typography>
                                                {/* <Label color={(item.block === '0' && 'error') || 'primary'}>
                                                    {item.block === '1' ? t('active') : t('band')}
                                                </Label> */}
                                            </TableCell>
                                            {property?.map((p, idx) => {
                                                const match = item?.properties_device?.find((d) => d.label === p.label);
                                                return (
                                                    <TableCell key={idx} align="right">
                                                        {match?.value ?? ''}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        deleteTableExcel();
                        setDataExcel([]);
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />

                <ButtonAction onClick={handleOnClick} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default UpdateDeviceLocationExcelModal;
